import { Outlet, Link, useLocation } from 'react-router-dom'

import type { ReactElement } from 'react'

import { BackButton } from '@/components/shared/back-button'
import { MarketingBrand } from '@/features/marketing/components/marketing-brand'
import { cn } from '@/lib/cn'

export function AuthLayout(): ReactElement {
  const { pathname } = useLocation()
  // O cadastro tem formulário em duas colunas a partir de `sm` e precisa de mais largura; as
  // outras três telas de auth continuam numa coluna estreita.
  const columnWidth = pathname === '/sign-up' ? 'max-w-2xl' : 'max-w-md'

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center gap-8 overflow-hidden bg-slate-950 px-4 py-12 text-slate-100">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(50%_50%_at_50%_0%,rgba(37,99,235,0.2),transparent),radial-gradient(40%_40%_at_100%_100%,rgba(139,92,246,0.15),transparent)]"
      />
      <Link
        to="/"
        className="relative rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
      >
        <MarketingBrand />
      </Link>
      {/* No desktop ancora no canto superior esquerdo da tela; no mobile fica no fluxo, entre a
          marca e o card. `self-start` impede que ele estique e vire uma faixa de hover. */}
      <BackButton className="relative z-10 self-start text-slate-300 hover:bg-white/5 hover:text-white sm:absolute sm:left-6 sm:top-6 sm:ml-0" />
      <div className={cn('relative w-full', columnWidth)}>
        <Outlet />
      </div>
    </div>
  )
}
